import * as React from 'react';
import { inject } from 'mobx-react';

import { withLocalization } from 'bernie-l10n';

import { ESSAdapter, UitkTypeahead, TypeaheadRenderType } from 'uitk-react-typeahead';
import {TypeaheadProps} from 'src/components/common/modules/form/types.d';
import { checkValue } from 'src/components/common/helper';


export interface LocationState {
  selectedValue: any;
  placeHolderTxt: any;
  hasVisibleLabel: boolean;
}

// fields to reset on location change
export const RESET_FIELDS = [
  'poi', // Exp 28074: LS_Top_Attractions_Filter_by_Popularity
  'hotelName',
  'group'
];
@withLocalization
//@FormFieldBinding
@inject('context')
export class Typeahead extends React.Component<TypeaheadProps, LocationState> {
  constructor(props) {
    super(props);

    let defaultVal = '';
    if (props.value !== undefined && props.value !== '') {
      defaultVal = props.value;
    }

    this.state = {
      selectedValue: defaultVal,
      placeHolderTxt: props.placeholder,
      hasVisibleLabel: true
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.closeTypeahead = this.closeTypeahead.bind(this);
  }
  
  handleChange(selection) {
    const element = document.getElementById(this.props.name);
    if (checkValue(element)) {
      element.classList.remove('value-selected');
    }
    this.setState({ selectedValue: selection.term }, () => {
      if (checkValue(element)) {
        element.classList.add('value-selected');
      }
      this.props.updateModel(selection.term, this.props.name);
    });
  }

  handleClear() {
    this.setState({ selectedValue: '' });
  }

  closeTypeahead() {
    document.body.classList.remove('has-dialog');
    if (this.state.selectedValue.trim().length === 0) {
      const element = document.getElementById(this.props.name);
      if (checkValue(element)) {
        element.classList.remove('value-selected');
      }
      this.props.updateModel('', this.props.name);
    }
    this.props.closePopup && this.props.closePopup();
  }

  onClickTypeahead(){
    if(!(window.innerWidth > 1024)){
      document.body.classList.add('has-dialog');
    }    
  }

  render() {
    const { context, label } = this.props;
    let inputVal = this.state.selectedValue;
    if (checkValue(this.props.value)) {
      inputVal = this.props.value;
      const element = document.getElementById(this.props.name);
      if (checkValue(element)) {
        element.classList.add('value-selected');
      }
    }

    return (
      <UitkTypeahead
        adapter={
          new ESSAdapter({
            client: 'HotelsLandingPage',
            dest: true,
            domain: 'https://www.expedia.com/',
            expuserid: -1,
            features: 'ta_hierarchy|postal_code|contextual_ta',
            guid: context && context.deviceId,
            lob: this.props.lob,
            locale: context && context.locale,
            maxResults: 10,
            regionType: 2047,
            siteId: context && context.site && context.site.id
          })
        }
        allowExactMatch={true}
        icon={this.props.icon}
        label={label}
        name={this.props.name}
        onUpdate={this.handleChange}
        stid={this.props.controlid}
        //toolbarVersion={TypeaheadToolbarVersion.V2}
        handleClear={this.handleClear}
        hasClearButton={this.props.hasClearButton}
        value={inputVal}
        typeaheadPlaceholder={this.state.placeHolderTxt}
        renderType={ (window.innerWidth > 1024 || (window.innerWidth > 575 && this.props?.isHeroWizard)) ? TypeaheadRenderType.MENU : TypeaheadRenderType.DIALOG}
        invalid={this.props.error}
        onDismiss={this.closeTypeahead}
        hasVisibleLabel={true}
        placeholder={''}
        id="adaptiveTypeaheadExample"
        onClick={this.onClickTypeahead}
        typeaheadEmptyResultPlaceholder={this.props?.typeaheadEmptyResultPlaceholder}
      />
    );
  }
}

